import React from 'react'
import PropTypes from 'prop-types'
import { formatDecimal } from 'utils/masks'
import './tableaccuracy.css'

const COLUMNS = [
  'dsDescription',
 
  'dsJanuary',
  'dsFebruary',
  'dsMarch',
  'dsApril',
  'dsMay',
  'dsJune',
  'dsJuly',
  'dsAugust',
  'dsSeptember',
  'dsOctober',
  'dsNovember',
  'dsDecember',
  'dsTotal',
]

class Tables extends React.Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    groupBy: PropTypes.string.isRequired,
    sectionsAccuracyList: PropTypes.array,
  }

  constructor(props) {
    super(props);
    this.state = {
      scrollAmount: 0
    };
  }

  getElementScrollbarWidth(element) {
    return element.offsetWidth - element.clientWidth;
  }

  handleScroll = () => {
    const scrollAmount = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollVertical = document.documentElement.scrollTop
    
    
    this.setState({ scrollAmount });
    const tableElement = document.querySelector('.accuracy-headers');
    const titleElement = document.querySelector(".sections-accuracy-fixed-title")
    
    if(scrollVertical > 22 && titleElement) {
      titleElement.classList.add("sections-accuracy-fixed-title-shadow")
    }
    else {
      titleElement.classList.remove("sections-accuracy-fixed-title-shadow")
    }
    const allTableElement = document.querySelectorAll(".accuracy-data-table")
    if (tableElement) {

      if(window.innerWidth + scrollAmount > (tableElement.clientWidth + 90)) {
        tableElement.classList.remove('accuracy-headers-spacing-table-right');
        allTableElement.forEach(table => table.classList.remove('accuracy-headers-spacing-table-all-right'));
      }
      else {
        tableElement.classList.add('accuracy-headers-spacing-table-right');
        allTableElement.forEach(table => table.classList.add('accuracy-headers-spacing-table-all-right'));
  
      }

      if (scrollAmount > 20) {
        tableElement.classList.add('accuracy-headers-spacing-table');
        allTableElement.forEach(table => table.classList.add('accuracy-headers-spacing-table-all'));
       
      } else {
        tableElement.classList.remove('accuracy-headers-spacing-table');
        allTableElement.forEach(table => table.classList.remove('accuracy-headers-spacing-table-all'));
      }
    }
  };

  componentDidMount() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }


  applyMask = (type, value) => {
    switch (type) {
      case 'decimal':
        return value !== undefined
          ? `${this.renderDecimalField(Math.round(value * 100) / 100)}%`
          : this.renderGeneralField(value)
      case 'general':
      default:
        return this.renderGeneralField(value)
    }
  }

  
  renderGeneralField = (value) => (value ? value.toLowerCase() : '-')

  renderDecimalField = (value) => {
    const { translate } = this.props
    return formatDecimal(value, translate)
  }

  renderBodyTableinternal = (rows) =>
    rows.map((row, i) => this.renderTableInternalBody(row, i))

  renderTableInternalBody = (row, i) => {
    const columns = COLUMNS

    return (
      <tr key={i}>
        {columns.map((column, j) => {
          const mask = column === 'dsDescription' ? 'general' : 'decimal'
          const value = row[column]
          return (
            <td
              key={j}
              className={` ${column === "separator" ? "sm-col-sep" : ""} ${column !== 'dsDescription' ? 'sm-col' : 'capitalize'}`}
            >
              {column !== "separator" && this.applyMask(mask, value)}
            </td>
          )
        })}
      </tr>
    )
  }

  render() {
    const { translate, groupBy, sectionsAccuracyList } = this.props

    if (sectionsAccuracyList && sectionsAccuracyList.length > 0) {
      sectionsAccuracyList[0].total.dsDescription = translate(
        'sectionAccuracy.total-lmb'
      )
    }

    return (
      <>
        <div className='new-style-table'>
          <div className='floating-headers'>
            <div style={{paddingBottom: 0}} className='outer-table new-outer-table'>
              <table
                cellPadding={0}
                cellSpacing={0}
                className='new-table accuracy-headers'
              >
                <thead>
                  <tr>
                    <th className='sections-acc-first-th' style={{fontWeight:600, color: "#3C3738"}} >
                      {groupBy === 'store'
                        ? "Total lojas"  
                        : "Total seções" }
                    </th>
                  
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsJanuary')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsFebruary')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsMarch')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsApril')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsMay')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsJune')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsJuly')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsAugust')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsSeptember')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsOctober')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsNovember')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsDecember')}
                    </th>
                    <th width='100' className='sm-col'>
                      {translate('sectionAccuracy.dsTotal')}
                    </th>
                  </tr>
                  {sectionsAccuracyList &&
                    sectionsAccuracyList.length > 0 &&
                    this.renderTableInternalBody(
                      sectionsAccuracyList[0].total,
                      99
                    )}
                </thead>
              </table>
            </div>
          </div>
          <div className='outer-table new-outer-table'>
            {sectionsAccuracyList.map((element, i) => {
              element.subTotal.dsDescription = translate(
                'sectionAccuracy.dsTotal'
              )
              const removeStoreStr =
                groupBy === 'store'
                  ? element.header.replace('LOJA', '')
                  : element.header
              return (
                <>
                  <div className='sections-accuracy-fixed-title'>
                    <p > {this.applyMask(
                      'general',
                      `${translate(
                        groupBy === 'section'
                          ? ""
                          : ""
                      )} ${removeStoreStr}`
                    )} 
                    </p>

                  </div>
                  <table
                    cellPadding={0}
                    cellSpacing={0}
                    className='new-table accuracy-data-table'
                    key={i}
                  >
                      <thead>
                      <tr>
                    <th className='sections-acc-first-th' style={{fontWeight:600, color: "#3C3738"}} >
                     
                    </th>
                   
                    <th width='100' className='sm-col'>
                      
                    </th>
                    <th width='100' className='sm-col'>
                   
                    </th>
                    <th width='100' className='sm-col'>
                     
                    </th>
                    <th width='100' className='sm-col'>
                     
                    </th>
                    <th width='100' className='sm-col'>
                     
                    </th>
                    <th width='100' className='sm-col'>
                     
                    </th>
                    <th width='100' className='sm-col'>
                 
                    </th>
                    <th width='100' className='sm-col'>
                     
                    </th>
                    <th width='100' className='sm-col'>
                    
                    </th>
                    <th width='100' className='sm-col'>
                      
                    </th>
                    <th width='100' className='sm-col'>
                     
                    </th>
                    <th width='100' className='sm-col'>
                     
                    </th>
                    <th width='100' className='sm-col'>
                      
                    </th>
                  </tr>
                      </thead>
                      <tbody>{this.renderBodyTableinternal(element.lines)}</tbody>
                      <tfoot>
                        {this.renderTableInternalBody(element.subTotal, 98)}
                      </tfoot>
                    </table>
                  </>
              )
            })}
          </div>
        </div>
      </>
    )
  }
}

export default Tables
export { Tables }
